import ECA from '../components/ECA';
import React from 'react';
import GovList from "../../GovList";
import FRP from "../components/FRP";
import APC from "../components/APC";
import GUARANTEES from "../components/GUARANTEES";
import KMDA from "../components/KMDA";
import eReceipt from "../components/eReceipt";
import Leasing from "../components/Leasing";
import LightHouse from "../components/LightHouse";

export default function template() {
    let Component = null,
        { match = {} } = this.props;
    if (match.params.action && match.params.type) {
        switch (match.params.action) {
            case 'eca':
                Component = ECA;
                break;
            case 'frp':
                Component = FRP;
                break;
            case 'apc':
                Component = APC;
                break;
            case 'gov_guarantees':
                Component = GUARANTEES;
                break;
            case 'kmda':
                Component = KMDA;
                break;
            case 'e-receipt':
                Component = eReceipt;
                break;
            case 'leasing-5-7-9':
                Component = Leasing;
                break;
            case 'light-house':
                Component = LightHouse;
                break;
            default:
                Component = GovList;
                break;
        }
    } else {
        Component = GovList;
    }

    return (
        <div className="module-business module-gov">
            <Component {...this.props} />
        </div>
    );
}
